<template>
<div class="base-modal">
    <base-header v-once pageName="상세검색" :popup="true"></base-header>
    <section id="wrap">
        <div class="detail-search">
            <dl>
                <dt>구분</dt>
                <dd class="flex-left">
                    <span class="checkBtn">
                        <input type="checkbox" name="group1" id="group1-1" v-model="gubun" value="COGA2">
                        <label for="group1-1">마스터</label>
                    </span>
                    <span class="checkBtn">
                        <input type="checkbox" name="group1" id="group1-2" v-model="gubun" value="COG03">
                        <label for="group1-2">1급</label>
                    </span>
                    <span class="checkBtn">
                        <input type="checkbox" name="group1" id="group1-3" v-model="gubun" value="COG04">
                        <label for="group1-3">2급</label>
                    </span>
                    <span class="checkBtn">
                        <input type="checkbox" name="group1" id="group1-4" v-model="gubun" value="COG05">
                        <label for="group1-4">3급</label>
                    </span>
                    <span class="checkBtn">
                        <input type="checkbox" name="group1" id="group1-5" v-model="gubun" value="COG06">
                        <label for="group1-5">파트너</label>
                    </span>
                </dd>
                <dt>차월</dt>
                <dd class="flex-left">
                    <span class="checkBtn">
                        <input type="checkbox" name="group2" id="group2-1" v-model="chawol" value="1">
                        <label for="group2-1">1차월</label>
                    </span>
                    <span class="checkBtn">
                        <input type="checkbox" name="group2" id="group2-2" v-model="chawol" value="2">
                        <label for="group2-2">2~3차월</label>
                    </span>
                    <span class="checkBtn">
                        <input type="checkbox" name="group2" id="group2-3" v-model="chawol" value="3">
                        <label for="group2-3">4~6차월</label>
                    </span>
                    <span class="checkBtn">
                        <input type="checkbox" name="group2" id="group2-4" v-model="chawol" value="4">
                        <label for="group2-4">7차월 이상</label>
                    </span>
                </dd>
                <dt>가동상태
                    <base-tooltip tipTxt="미가동 0원, 가동(1원 ↑), 실활동(300만 ↑)"></base-tooltip>
                </dt>
                <dd class="flex-left">
                    <span class="checkBtn">
                        <input type="checkbox" name="group3" id="group3-1" v-model="gadong" value="NO">
                        <label for="group3-1">미가동</label>
                    </span>
                    <span class="checkBtn">
                        <input type="checkbox" name="group3" id="group3-2" v-model="gadong" value="GA">
                        <label for="group3-2">가동</label>
                    </span>
                    <span class="checkBtn">
                        <input type="checkbox" name="group3" id="group3-3" v-model="gadong" value="SIL">
                        <label for="group3-3">실활동</label>
                    </span>
                </dd>
            </dl>
        </div>
    </section>
    <div class="btnWrap">
        <button type="button" class="black" @click="clear">초기화</button>
        <button type="button" class="red" @click="search">검색</button>
    </div>
</div>
</template>

<script>
export default {
    data() {
      return{
          gubun :[],
          chawol :[],
          gadong :[],
      };
    },
    created(){
        if(this.$route.query.gubun){
            this.gubun = this.$route.query.gubun.split(",");
        }
        if(this.$route.query.chawol){
            this.chawol = this.$route.query.chawol.split(",");
        }
        if(this.$route.query.gadong){
            this.gadong = this.$route.query.gadong.split(",");
        }
    },
    methods: {
        close: function() {
            this.$utils.nativeIf.outbound.close();
        },
        clear:function(){
            this.gubun = [];
            this.chawol = [];
            this.gadong = [];
        },
        search : function(){
            var data = {
                gubun:this.gubun,
                chawol:this.chawol,
                gadong:this.gadong
            }
            var child = {
                name: "orgnz-search-pop",
                data: data
            };
            this.$utils.nativeIf.outbound.sendChildData(child);
        }
    }
};
</script>
